import type {Asset} from "~/graphql/__generated__/graphql"
import type AssetLocal from "~/libs/interfaces/AssetLocal"

const assetLocalFactory = {
  createAssetLocal(asset: Asset): AssetLocal {
    return {
      ...asset,
      isLoading: false,
    }
  }
}
export default assetLocalFactory
